import { combineReducers } from 'redux';
import bycService from './bycService';
import researchableApiService from './researchableApiService';

export default combineReducers({
  bycService,
  researchableApiService,
});
